<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <!-- <transition name="sidebarLogoFade">
      <div class="sidebar-logo-link">
        <div class="sidebar-title">
          <img src="../../../assets/images/lixiao.png" class="sidebar-logo" >
          <h1 v-show="!collapse" class="sidebar-title-txt">{{ title }}</h1>
        </div>

        <div class="sidebar-user" v-if="!collapse">
          <div class="avatar">
            <img
              src="https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png"
              alt=""
            />
          </div>
          <p>{{username}}</p>
        </div>
      </div>
    </transition> -->

    
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  watch:{
    collapse(newval){
      // console.log(newval)
    }
  },
  created(){
    let data = localStorage.getItem('userInfo');
    let userInfo = JSON.parse(data);
    this.username = userInfo.name;
  },
  data() {
    return {
      title: "迎新管理",
      username:'',
    };
  },
  methods:{
    handleToggleRole(command) {
      // EventBus.$emit("toggleRole", command);
      // sessionStorage.setItem("role", command);
      switch (command) {
        case "a":
          // this.handleLogout();
          localStorage.clear();
          this.$router.replace('/login')
          break;
      }
    },
  }
};
</script>

<style lang="less" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity .38s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  // background-color: #159ae8;
  .sidebar-logo-link {
    height: 100%;
    width: 100%;

    .sidebar-title {
      height: 50px;
      line-height: 50px;
      // background: #87a8eb;;
      background-color: #047bec;
      overflow: hidden;
      .sidebar-logo {
        width: 32px;
        height: 32px;
        // font-size: 24px;
        vertical-align: middle;
        margin-left: 15px;
        margin-right: 12px;
        // color: rgb(191, 203, 217);
      }

      .sidebar-title-txt {
        display: inline-block;
        margin: 0;
        color: #fff;
        font-weight: 600;
        line-height: 50px;
        font-size: 18px;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        vertical-align: middle;
        transition: all ease .38s;
      }
    }
    .sidebar-user {
      padding: 30px 0 15px;
      transition: all ease .38s;
      .avatar {
        text-align: center;
        img {
          width: 46px;
          height: 46px;
          border-radius: 50%;
        }
      }
      > p {
        // color: #fff;
        color: #3c3c3c;
        font-size: 16px;
        text-align: center;
        line-height: 30px;
      }
    }
  }

}
</style>
